import axios, { AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { API_URL } from '../config';

// Configuração base do axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Configurações adicionais para evitar problemas de CORS
  withCredentials: false,
  timeout: 30000, // 30 segundos de timeout
});

// Interceptor para adicionar o token JWT em todas as requisições
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = localStorage.getItem('bravobet_token');
    if (token && config.headers) {
      // Usar o formato correto para o cabeçalho de autorização (Bearer token)
      config.headers['Authorization'] = `Bearer ${token}`;
      
      // Manter o cabeçalho antigo para compatibilidade com versões anteriores da API
      // que ainda possam estar usando x-auth-token
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    console.error('Erro na requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de resposta (como token expirado)
api.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  (error: AxiosError): Promise<AxiosError> => {
    if (error.response && error.response.status === 401 && window.location.pathname !== '/login') {
      // Token expirado ou inválido. Preserva pra onde o usuário estava (ex:
      // no meio de uma tarefa) e avisa explicitamente o motivo — antes isso
      // acontecia em silêncio, parecendo "a página recarregou sozinha" sem
      // nenhuma explicação, perdendo o contexto de onde a pessoa estava.
      localStorage.removeItem('bravobet_token');
      localStorage.removeItem('bravobet_usuario');
      sessionStorage.setItem('sessaoExpirada', '1');
      const destino = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/login?next=${destino}`;
    }

    return Promise.reject(error);
  }
);

export default api;
